<template>
  <div
    :style="
      'background-color: ' +
        ((webTheme &&
          webTheme.colors &&
          webTheme.colors.canvas &&
          webTheme.colors.canvas.hexa) ||
          '#ffffff')
    "
  >
    <component
      :is="component.id"
      v-for="component in authentication"
      :key="component.idx"
      :component="component"
    ></component>
    <v-row no-gutters justify="center" v-if="authentication.length === 0">
      <v-col>
        <v-card class="pa-3 grey lighten-4" elevation="0">
          <v-card class="mt-3 mx-3 pa-6 dotted" elevation="0" height="100vh">
            <v-row no-gutters justify="center" class="page-heading mb-3">
              Authentication
            </v-row>
            <v-row no-gutters justify="center" class="page-subheading mb-3">
              There are no active authentication components.
            </v-row>
            <v-row no-gutters justify="center" class="mt-6">
              <v-btn color="primary" @click="debugInfo">Show Debug Info</v-btn>
            </v-row>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AuthSignIn from "./ViewComponents/Shared/Authentication/SignIn.vue";
import HeadingSection from "./ViewComponents/Shared/HeadingSection.vue";
import Banner from "./ViewComponents/Header/Banner.vue";
import ImageComponent from "./ViewComponents/Shared/Image.vue";
import TextOneCol from "./ViewComponents/Shared/TextOneCol.vue";
import TextTwoCol from "./ViewComponents/Shared/TextTwoCol.vue";
import TextThreeCol from "./ViewComponents/Shared/TextThreeCol.vue";

export default {
  components: {
    AuthSignIn,
    HeadingSection,
    Banner,
    ImageComponent,
    TextOneCol,
    TextTwoCol,
    TextThreeCol
  },
  created() {
    console.log("🔐 ViewSignIn created");
    console.log("Current program:", this.$store.getters.currentProgram);
    console.log("WebTheme:", this.webTheme);
    console.log("Authentication components:", this.authentication);
  },
  data: () => ({}),
  computed: {
    grid() {
      return this.$store.getters.grid;
    },
    programId() {
      return this.$store.getters.programId;
    },
    webTheme() {
      const program = this.$store.getters.currentProgram;
      return (program && program.webTheme) || {};
    },
    selectedPageTemplate() {
      return this.$store.getters.selectedPageTemplate;
    },
    designDrawer() {
      return this.$store.getters.designDrawer;
    },
    authentication() {
      const components =
        this.webTheme &&
        this.webTheme.auth &&
        this.webTheme.auth.signin &&
        this.webTheme.auth.signin.components;
      console.log("🔐 Authentication components:", components);
      return components || [];
    },
    authComponentsLength() {
      return (this.authentication && this.authentication.length) || 0;
    },
    header() {
      return (
        (this.webTheme &&
          this.webTheme.header &&
          this.webTheme.header.components) ||
        []
      );
    },
    // Member site specific models
    currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    debugInfo() {
      console.log("=== SIGNIN DEBUG INFO ===");
      console.log("Current program:", this.$store.getters.currentProgram);
      console.log("WebTheme:", this.webTheme);
      console.log("WebTheme.auth:", this.webTheme && this.webTheme.auth);
      console.log(
        "WebTheme.auth.signin:",
        this.webTheme && this.webTheme.auth && this.webTheme.auth.signin
      );
      console.log("Authentication components:", this.authentication);
      console.log("========================");
    }
  }
};
</script>

<style scoped>
.dotted {
  border: 1px dashed rgb(184, 184, 184) !important;
}
</style>
